import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SwaggerService } from 'app/providers/api';
import { useApiQuery } from 'shared/hooks/useApiQuery';

const useIntegrationInboundDocsPage = () => {
  const { sellerId } = useParams();
  const [inboundSwagger, setInboundSwagger] = useState<any>(null);

  const domain = window.location.hostname;
  const inboundApiUrl =
    domain === 'localhost'
      ? 'http://localhost:8003'
      : `https://inbound-api.${domain.replace('seller.', '')}`;

  const { data: swaggerData, isLoading } = useApiQuery(
    ['getInboundSwagger'],
    () => SwaggerService.fetchInboundSwagger(inboundApiUrl),
    {
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000,
    },
  );

  useEffect(() => {
    if (swaggerData) {
      setInboundSwagger(swaggerData);
    }
  }, [swaggerData]);

  return {
    sellerId,
    isLoading,
    inboundSwagger,
  };
};

export default useIntegrationInboundDocsPage;
